import React from "react";
import { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "../utils/comman/Dashboard.css";
import Select from "react-select";

import { TiEyeOutline } from "react-icons/ti";

import { toast } from "react-toastify";
import { useEffect } from "react";

import { useSelector } from "react-redux/es/exports";
import Pagination from "../utils/Pagination";
import axiosinstances from "../Helper/useAxios";
import { v4 as uuid4 } from "uuid";
import {
  darkenColor,
  primaryColor,
  requestLoading,
  stylesofStype,
} from "../utils/comman/Common";
import {
  REQID,
  TXNID,
  setpageContent,
  UTR,
  VPA,
  ODRCODE,
  Statusoptions,
  searchbyOptionsForTicket,
  TicketStatusoptions,
} from "../utils/Constant";

import { useNavigate } from "react-router-dom";
import UpdatTicket from "../components/Model/UpdateToken";
import { appVersion } from "../version";

const TokenList = () => {
  const navigate = useNavigate();
  const profileInfo = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  console.log("sessionId", sessionId, reqId);
  const e = JSON.parse(sessionStorage.getItem("token"));
  // const accessPath =  process.env.REACT_APP_accessPath
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [statusOption, setStatusOption] = useState(Statusoptions);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedTraxn, setSelectedTraxn] = useState(null);
  const [attachmentId, setattachmentId] = useState(null);

  const [show, setShow] = useState(false);
  //statusDate
  const today = new Date().toISOString().split("T")[0];
  const [statusDate, setStatusDate] = useState(today);
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [searched, setSearched] = useState({
    name: "",
    typing: false,
    typingTimeout: 0,
  });

  const [table, settable] = useState([]);
  const [backupTableData, setBackupTableData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [searchedBy, setSearchedBy] = useState();
  const [searchedByItem, setSearchedByItem] = useState(
    searchbyOptionsForTicket
  );
  const [searchedByItemShow, setSearchedByItemShow] = useState(true);
  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const finalStatus = selectedStatus.map((item) => item.value);
  const url = process.env.REACT_APP_TICKET_LIST;

  const [transactionStatuswithAmount, setTransactionStatuswithAmount] =
    useState([
      {
        id: "SUCCESS",
        count: 0,
        total: 0,
      },
      {
        id: "PENDING",
        count: 0,
        total: 0,
      },
      {
        id: "FAILED",
        count: 0,
        total: 0,
      },
    ]);
  const [ticketRequest, setticketRequest] = useState({
    txnDetails: "",
    status: "",
    createdBy: profileInfo?.id,
    description: "",
    userUtr: "",
    userTxnDate: "",
    comments: null,
    attachmentId: "",
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const storeData = useSelector(
    (state) => state?.configDetailsreducer?.details
  );

  const [warningShown, setWarningShown] = useState(false);
  const currentVersionfromApi =
    (Array.isArray(storeData) &&
      storeData.filter(
        (val) => val.id == "REACT_APP_QRBONPAY_MER_PORTAL_CUREENT_VERSION"
      )) ||
    [];
  useEffect(() => {
    if (
      appVersion &&
      Array.isArray(currentVersionfromApi) &&
      currentVersionfromApi.length > 0
    ) {
      const apiCurrentVersion = currentVersionfromApi[0]?.value;
      if (apiCurrentVersion !== appVersion && !warningShown) {
        toast.warn(
          `Kindly reload your application, a new version ${apiCurrentVersion} is available.`
        );
        setWarningShown(true); // Set the flag to prevent further warnings
      }
    }
  }, [currentVersionfromApi, appVersion, warningShown]);
  const toggleDropdown = (e) => {
    console.log("Filter toggle clicked");
    e.stopPropagation();
    setIsDropdownOpen((prevState) => !prevState);
  };
  console.log("ticketRequest", ticketRequest);
  const fromatedFromDate = formDate !== null ? `${formDate}T00:00:00` : null;
  const formatedToDate = toDate !== null ? `${toDate}T23:59:59` : null;
  var request = {
    mid: mid,
    resolved: [true, false],
    fromDate: fromatedFromDate,
    toDate: formatedToDate,
    user: null,
    merchant: true,
    fromDate: null,
    toDate: null,
    statuses: finalStatus,
    pageNum: paginationDetails.currentPage - 1,
    perPage: paginationDetails.postsPerPage,
  };
  const getUniqId = () => {
    const uuid = uuid4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    setSearchedByItemShow(true);
    setSearchedBy();
  }, [search]);

  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);

  const uploadFile = async (files) => {
    if (!files) {
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", files);
      const url = "/api/v1/upi/file/upload/1209600";
      const response = await axiosInstance.post(url, formData, { headers });

      if (response.status == 200 && response.data?.id !== undefined) {
        console.log("File uploaded successfully", response.data);
        // Optionally handle response data
        toast.success("File has added");
        setattachmentId(response.data);
        return response;
      } else {
        toast.error(
          "unable to upload image and file permitted size is 1048576 bytes"
        );
        console.error("Failed to upload file");
      }
    } catch (error) {
      toast.error("Error uploading file:", error);
      console.error("Error uploading file:", error);
    }
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const res = await uploadFile(file);
  };

  const handalpageclick = async (index) => {
    setPaginationDetails((prev) => {
      return { ...prev, currentPage: index };
    });

    request["fromDate"] = fromatedFromDate;
    request["toDate"] = formatedToDate;
    request["statuses"] = finalStatus;
    request["pageNum"] = index - 1;
    request["perPage"] = paginationDetails.postsPerPage;

    if (url && request) {
      callApis(url, request);
    }
  };

  const searchdata = (event) => {
    if (searched.typingTimeout) {
      clearTimeout(searched.typingTimeout);
    }
    if (!searched.typing) {
      // setRetailerList([])
    }

    if (event.target.value !== "") {
      const trimSearch = event.target.value.trim();
      setSearched({
        name: trimSearch,
        typing: true,
        typingTimeout: setTimeout(function () {
          // sendToParent(searched.name);
          if (event.target.value) {
            setSearchTyping(true);
            setsearch(trimSearch);
          } else {
          }
        }, 500),
      });
    } else {
      setsearch(event.target.value);
      setSearched({
        typing: false,
      });
    }
  };

  useEffect(() => {
    const finalStatus = selectedStatus.map((item) => item.value);
    // const url = process.env.REACT_APP_HISTORY;

    request["fromDate"] = fromatedFromDate;
    request["toDate"] = formatedToDate;
    request["statuses"] = finalStatus;
    request["pageNum"] = paginationDetails.currentPage - 1;
    request["perPage"] = paginationDetails.postsPerPage;

    if (url && request) {
      callApis(url, request);
    }
  }, []);

  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,

    // "access-path":null
  };
  async function callApis(url, request) {
    await fetchpagedata(url, request);
  }

  const fetchpagedata = async (url, request) => {
    setDataLoading(true);
    try {
      const res = await axiosInstance.post(url, request, { headers });

      if (res.status === 200 && res?.data?.tickets !== undefined) {
        settable(res.data.tickets);
        setBackupTableData(res.data);
        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: res.data?.totalCount,
            totalPages: res.data?.pages,
          };
        });
      } else {
        console.log("res====>", res);
        throw new Error(res?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      setIsDataLoaded(false);
      console.error("Error", error);

      toast.error(error?.message);
      return false;
    }
  };
  const updateTickets = async (e) => {
    e.preventDefault();
    const requestPayload = {
      ticketId: selectedTraxn?.id,
      updatedBy: profileInfo?.id,
      userUtr: ticketRequest?.userUtr,
      userTxnDate: ticketRequest.userTxnDate,
      comments: ticketRequest?.comments,
      attachmentId: attachmentId?.id,
      //  internalComments : "",
      //  internalAttachmentId : "",
      status: ticketRequest?.status,
    };
    if (ticketRequest?.comments == "") {
      toast.error("Enter Your Comments");
      return;
    }
    if (!validateUTR(ticketRequest?.userUtr)) {
      toast.error("Utr is not valid");
      return;
    }

    if (requestPayload?.ticketId == null || requestPayload?.ticketId == "") {
      toast.error("ticketId is required to fill");
      return;
    }
    if (requestPayload?.status == null || requestPayload?.status == "") {
      toast.error("status is not Valid and its required to fill");
      return;
    }

    //userTxnDate
    if (requestPayload?.userTxnDate == "") {
      toast.error("User Txn Date By is not Valid and its required to fill");
      return;
    }

    setDataLoading(true);
    const API_ENDPOINT = "/api/v1/upi/ticket/update";
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (response.status === 200 && response?.data?.id !== undefined) {
        toast.success(
          `Your ticket has raised and ref is ${response?.data?.id}`
        );
        request["fromDate"] = fromatedFromDate;
        request["toDate"] = formatedToDate;
        request["statuses"] = finalStatus;
        request["pageNum"] = paginationDetails.currentPage - 1;
        request["perPage"] = paginationDetails.postsPerPage;

        if (url && request) {
          callApis(url, request);
        }
        setDataLoading(false);
        handleClose();
      } else {
        setDataLoading(false);
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };

  useEffect(() => {
    const finalStatus = selectedStatus.map((item) => item.value);

    request["fromDate"] = null;
    request["toDate"] = null;
    request["statuses"] = finalStatus;

    if (search.length > 2) {
      if (searchedBy == REQID) {
        request.requestId = search;
        callApis(url, request);
      } else if (searchedBy == TXNID) {
        request.txnId = search;
        callApis(url, request);
      } else if (searchedBy == ODRCODE) {
        request.orderCode = search;
        callApis(url, request);
      } else if (searchedBy == UTR) {
        request.userUtr = search;
        callApis(url, request);
      } else if (searchedBy == VPA) {
        request.vpa = search;
        callApis(url, request);
      }
    }
  }, [searchedBy]);

  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    setIsDropdownOpen(false);
    const finalStatus = selectedStatus.map((item) => item.value);

    const request = {
      mid: mid,
      requestId: "",
      orderCode: "",
      txnId: "",
      utr: "",
      vpa: "",
      fromDate: fromatedFromDate,
      toDate: formatedToDate,
      statuses: finalStatus,
      pageNum: paginationDetails.currentPage - 1,
      perPage: paginationDetails.postsPerPage,
    };
    if (url && request) {
      callApis(url, request);
      // setIsDropdownOpen(!isDropdownOpen);
    }
  };
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
    return `${formattedDate}_${formattedTime}`;
  };
  const convertToXLSX = (data, fileName) => {
    const parsedData = Papa.parse(data, { header: true });
    const worksheet = XLSX.utils.json_to_sheet(parsedData.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  };
  const onExportData = async () => {
    const expFileLength = 10000;
    const request = {
      mid: mid,
      requestId: "",
      orderCode: "",
      txnId: "",
      utr: "",
      vpa: "",
      fromDate: fromatedFromDate,
      toDate: formatedToDate,
      statuses: finalStatus,
      pageNum: 0,
      perPage: expFileLength,
    };
    const fetchExportdata = async (url, request) => {
      setDataLoading(true);
      const response = await axiosInstance
        .post(url, request, { headers })
        .then((res) => {
          setDataLoading(false);
          setIsDataLoaded(false);
          const fileName = `${getUniqId()}_${getCurrentDateTime()}`;
          convertToXLSX(res?.data, fileName);
        })
        .catch((err) => {
          console.log(err);
          setDataLoading(false);
          setIsDataLoaded(false);
          toast.error("Something went wrong");
        });

      if (response) {
        return response.data;
      }
      return false;
    };
    const url = "/api/v1/upi/q/payin/report";

    if (url && request) {
      const fileExport = await fetchExportdata(url, request, { headers });
    }
  };
  const ticketChangeHandle = (e) => {
    const { name, value } = e.target;
    console.log("validateUTR(value)", validateUTR(value));
    if (name == "userUtr") {
      const sanitizedValue = value.replace(/\D/g, "").substring(0, 12);
      setticketRequest({
        ...ticketRequest,
        userUtr: sanitizedValue,
      });
      return;
    }

    if (name !== "userUtr") {
      setticketRequest((pre) => ({ ...pre, [name]: value }));
    }
  };

  const resetApply = () => {
    setFinalSelectedStatus([]);
    setIsDropdownOpen(false);
    setSelectedStatus([]);
    setIsExportable(false);
    setFormDate("");
    setToDate("");

    if (url && request) {
      callApis(url, request);
      // setIsDropdownOpen(!isDropdownOpen);
    }
  };
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };

  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };
  const selectedTranxtForIssue = (e, data) => {
    e.preventDefault();
    setticketRequest((pre) => ({
      ...pre,
      userUtr: data?.userUtr,
      userTxnDate: data?.userTxnDate,
      status: data?.status,
    }));

    console.log("data", data);
    setSelectedTraxn(data);
    handleShow();
  };
  //editPlans
  const clearSearchData = () => {
    setsearch("");
    setSearchedBy();
    setSearched({ name: "", typing: false, typingTimeout: 0 });
    resetApply();
    setDataLoading(false);
    setIsDataLoaded(true);
    setPaginationDetails((prev) => {
      return {
        ...prev,
        totalPost:
          backupTableData?.totalElements !== undefined &&
          backupTableData?.totalElements,
        totalPages:
          backupTableData?.totalPages !== undefined &&
          backupTableData?.totalPages,
        currentPage:
          backupTableData?.currentPage !== undefined
            ? backupTableData?.currentPage + 1
            : 1,
      };
    });
  };

  // const percentage = 66;
  console.log("transactionStatuswithAmount", transactionStatuswithAmount);
  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + (currentValue?.count || 0),
    initialValue
  );
  const openDetailsPage = (data) => {
    navigate("/ticket-details", { state: { data: data, headers: headers } });
  };

  const bgColor = search.length > 3 ? "#FEC7B4" : "#848587";

  function validateUTR(utr) {
    // Check if UTR is exactly 12 digits
    if (!/^\d{12}$/.test(utr)) {
      return false;
    }

    // Get the last digit of the current year
    const currentYearLastDigit = new Date().getFullYear().toString().slice(-1);

    // Get the last two digits of the previous year
    const previousYearLastTwoDigits = (new Date().getFullYear() - 1)
      .toString()
      .slice(-2);

    // Get the current month and day
    const currentMonth = new Date().getMonth() + 1; // Add 1 to get the month number (January is 1, December is 12)
    const currentDay = new Date().getDate();

    // Check if today is January 1st and the UTR corresponds to December 31st of the previous year
    if (currentMonth === 1 && currentDay === 1) {
      // customLog("utr", utr);
      // customLog(utr[0], previousYearLastTwoDigits[1]);
      if (utr[0] === previousYearLastTwoDigits[1]) {
        return true;
      }
    }

    // Check if the first digit of the UTR matches the last digit of the current year
    if (utr[0] !== currentYearLastDigit) {
      return false;
    }

    return true;
  }

  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <div className="mid">
            <div className="container-fluid">
              <div className="maincard">
                <div className="tab-content" id="mobiletab">
                  <div
                    className="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <div style={{ marginTop: "0px" }} className="head">
                      <div className="search-filter-mobile-view">
                        <div
                          className="dropdown fltr"
                          id="search-filters-for-tickets"
                        >
                          <button
                            type="button"
                            title="Filter"
                            className="filter dropdown-toggle"
                            id="fillist"
                            data-bs-boundary="viewport"
                            onClick={toggleDropdown}
                            aria-expanded={isDropdownOpen}
                          >
                            Filter
                          </button>
                          <div
                            className={`dropdown-menu dropdown-menu-right ${
                              isDropdownOpen ? "show" : ""
                            }`}
                            id="filterbox"
                            aria-labelledby="fillist"
                          >
                            <form onSubmit={applyStatus}>
                              <div className="col-12 col-md-12 mb-2 border-bottom ">
                                <div className="form-floating">
                                  <div className="formselect mb-2">
                                    <label>Selected Status</label>
                                    <Select
                                      className="basic-multi-select"
                                      styles={stylesofStype}
                                      closeMenuOnSelect={false}
                                      components={{
                                        IndicatorsContainer: () => null,
                                        IndicatorSeparator: () => null,
                                      }}
                                      isMulti
                                      options={TicketStatusoptions}
                                      onChange={changeHandler}
                                      value={selectedStatus}
                                      placeholder=" select multiple option"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="filters">
                                <label for="select-state">From Date:</label>
                                <input
                                  type="date"
                                  onChange={fromDateHandler}
                                  value={formDate}
                                />
                              </div>

                              <div className="filters">
                                <label for="select-state">To Date:</label>
                                <input
                                  min={formDate}
                                  type="date"
                                  onChange={toDateHandler}
                                  value={toDate}
                                />
                              </div>

                              <div className="fbtn">
                                <button
                                  className="btn"
                                  type="submit"
                                  id="btnapply"
                                  disabled={checkDisable()}
                                >
                                  Apply
                                </button>
                                <button
                                  className="btn"
                                  type="reset"
                                  id="btnclear"
                                  onClick={resetApply}
                                >
                                  Clear
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>

                        <div
                          style={{
                            backgroundColor: primaryColor,
                          }}
                          id="search-filters-for-tickets"
                          className="search allsearch"
                        >
                          <form autocomplete="off" action="#">
                            <div className="autocomplete">
                              <input
                                id="myInput"
                                type="text"
                                name=""
                                style={{ backgroundColor: primaryColor }}
                                placeholder="Search"
                                value={searched?.name}
                                onChange={searchdata}
                              />
                              <button
                                type="button"
                                onClick={clearSearchData}
                                style={{
                                  position: "absolute",
                                  // backgroundColor: "#848587",

                                  backgroundColor: darkenColor(primaryColor),
                                }}
                                className="search-btn"
                              ></button>
                              {search !== undefined &&
                                search !== null &&
                                searchedByItemShow &&
                                search.length > 2 &&
                                searchTyping && (
                                  <div
                                    id="myInputautocomplete-list"
                                    className="autocomplete-items"
                                    style={{
                                      marginTop: "3px",
                                      borderTopLeftRadius: "7px",
                                    }}
                                  >
                                    <button
                                      style={{
                                        background: "#9FA6B2",
                                        width: "30px",
                                        height: "30px",
                                        fontSize: "20px",
                                        borderRadius: "20px",
                                        opacity: 1,
                                      }}
                                      type="button"
                                      className="close"
                                      aria-label="Close"
                                      onClick={() => setSearchTyping(false)}
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                    {search !== undefined &&
                                      search !== null &&
                                      search.length > 2 &&
                                      searchedByItem.map((val, index) => {
                                        return (
                                          <div
                                            key={index}
                                            onClick={() => {
                                              setSearchedBy(val);
                                              setSearchedByItemShow(false);
                                            }}
                                            style={{
                                              backgroundColor: `${
                                                searchedBy == val
                                                  ? "#d0d2d6"
                                                  : "#fff"
                                              }`,
                                            }}
                                          >
                                            {val}
                                            <input
                                              type="hidden"
                                              value="Denmark"
                                            />
                                          </div>
                                        );
                                      })}
                                  </div>
                                )}
                            </div>
                          </form>
                        </div>
                      </div>
                      <UpdatTicket
                        ticketRequest={ticketRequest}
                        tokenChangeHandle={ticketChangeHandle}
                        handleFileChange={handleFileChange}
                        // attachedFile={attachedFile}
                        createNewToken={updateTickets}
                        attachmentId={attachmentId}
                        show={show}
                        handleClose={handleClose}
                        handleShow={handleShow}
                      />
                    </div>
                    <div className="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div className="d-flex justify-content-center">
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            table?.map((data) => {
                              return (
                                <div className="txn-item" key={data.id}>
                                  <div className="txn-head" id="txnhead1">
                                    <div
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#txn1"
                                      aria-expanded="false"
                                      aria-controls="txn1"
                                    >
                                      <div
                                        className={`txncard ${
                                          data.resolved
                                            ? "success grbg"
                                            : "pending ylbg"
                                        }
                                      }`}
                                      >
                                        <div className="row">
                                          <div className="col-12 col-md-4">
                                            <div className="txntxt">
                                              <h6>
                                                <span>
                                                  {" "}
                                                  {data?.createdOn !==
                                                    undefined &&
                                                    data?.createdOn !== null &&
                                                    data?.createdOn
                                                      .replace("T", " ")
                                                      .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>

                                              <h4 style={{ float: "left" }}>
                                                {" "}
                                                <span
                                                  className={`${
                                                    data?.status === "RESOLVED"
                                                      ? "success"
                                                      : `${
                                                          data?.status ===
                                                          "IN_PROGRESS"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data.status}
                                                </span>
                                              </h4>
                                            </div>
                                          </div>
                                          <div className={"col-12 col-md-5"}>
                                            <div className="txntxt">
                                              <h5>
                                                <h6>
                                                  REQID:{" "}
                                                  {data?.payInTxn?.requestId}
                                                </h6>
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                            <div className="txntxt">
                                              <h6>
                                                UTR: {data?.payInTxn?.utr}
                                              </h6>
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                            class="col-12 col-md-1"
                                          >
                                            <div>
                                              <h4
                                                onClick={() =>
                                                  openDetailsPage(data)
                                                }
                                              >
                                                <TiEyeOutline
                                                  size={33}
                                                  style={{
                                                    color: primaryColor,
                                                  }}
                                                />
                                              </h4>
                                            </div>

                                            {/* <div >
                                            <h4 
                                             onClick={(e) =>
                                              selectedTranxtForIssue(
                                                e,
                                                data
                                              )
                                            }
                                            >
                                              <BiSolidMessageAltEdit
                                                size={25}
                                                style={{ color: "#009adb" }}
                                              />
                                            </h4>
                                            </div> */}
                                          </div>

                                          <div className="col-12 col-md-2">
                                            <div className="txntxt">
                                              <h4>
                                                ₹{" "}
                                                {
                                                  data?.payInTxn?.transaction
                                                    ?.amount
                                                }
                                              </h4>

                                              <h4>
                                                {" "}
                                                <span
                                                  className={`${
                                                    data?.payInTxn?.status ===
                                                      "SUCCESS_AUTO" ||
                                                    data?.payInTxn?.status ===
                                                      "SUCCESS_MANUAL"
                                                      ? "success"
                                                      : `${
                                                          data?.payInTxn
                                                            ?.status ===
                                                            "PENDING_PAYMENT" ||
                                                          data?.payInTxn
                                                            ?.status ===
                                                            "PAYMENT_PROCESSED" ||
                                                          data?.payInTxn
                                                            ?.status ===
                                                            "HUNG" ||
                                                          data?.payInTxn
                                                            ?.status ===
                                                            "ACCEPTED"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data?.payInTxn?.status}
                                                </span>
                                              </h4>
                                              {/* )} */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}

                          <div className="pager">
                            {table !== undefined &&
                              table !== null &&
                              table.length > 0 &&
                              search == "" && (
                                <p>
                                  {paginationDetails.currentPage !==
                                    undefined &&
                                    paginationDetails.currentPage !== null &&
                                    paginationDetails.totalPost !== undefined &&
                                    paginationDetails.totalPost !== null &&
                                    table !== undefined &&
                                    Array.isArray(table) &&
                                    setpageContent(
                                      paginationDetails.currentPage - 1,
                                      table.length,
                                      paginationDetails.totalPost
                                    )}
                                  {/* <button
                                    className={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export xlsx
                                  </button> */}
                                  {/* <button
                                    className={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export csv
                                  </button> */}
                                </p>
                              )}

                            {paginationDetails.totalPost !== undefined &&
                              paginationDetails.totalPost !== null &&
                              paginationDetails.totalPost > 10 &&
                              search == "" && (
                                <Pagination
                                  className="pagination-bar"
                                  currentPage={paginationDetails.currentPage}
                                  totalCount={paginationDetails.totalPost}
                                  pageSize={paginationDetails.postsPerPage}
                                  onPageChange={(page) => handalpageclick(page)}
                                />
                              )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default TokenList;
